import { SportMatchModel } from './odds';

export interface KnockOutMatch extends BaseMatchTournamentApiBackend {
    Round?: string;
    ExtraTimeChildMatchId?: number;
    PenaltyOuChildMatchId?: number;
    PenaltyHdpChildMatchId?: number;
    isResult?: boolean;
}

export interface Group {
    Group: string;
    CountryCode: string;
    TeamId: number;
    TeamName?: string | null;
    Country?: string | null;
    Matches: BaseMatchTournamentApiBackend[];
}

export interface Outright {
    Type: string;
    LeagueId: number;
    OrId: number;
    Status: string;
}

export interface Point {
    Group: string;
    IBCTeamId: number;
    TeamName: string;
    CountryCode: string | null;
    MatchPlayed: number;
    Points: number;
    Goals: number;
    MatchWin: number;
    MatchDraw: number;
    MatchLose: number;
    Outright: Outright[];
}


export interface BaseMatchTournamentApiBackend {
    IBCHomeId: number;
    HomeName?: string;
    HomeScore: number;
    HomeCountryCode: string;
    IBCAwayId: number;
    AwayName?: string;
    AwayScore: number;
    AwayCountryCode: string;
    IBCMatchId: number;
    MatchStatus: number;
    GlobalMatchTime?: string;
    KickoffTime?: string;
    Group?: string;
    MatchInfoShowOdds?: SportMatchModel;
    MatchStage?: string;
    HomePenaltyScore: number;
    AwayPenaltyScore: number;
    CountryName: string;
}

export const MatchStatusEnum = {
	deadball: 0,
	live: 1,
	extratime: 2,
	penalty: 3,
	completed: 4
};

export const KnockoutChildDisplayText = {
	R: ['lbl_ECPRoundOf16', 0],
	QF: ['lbl_ECPQuarterFinals', 1],
	SF: ['lbl_ECPSemiFinals', 2],
	F: ['lbl_BetradarVSFinal', 3],
}

export type KnockoutchildType = {
    [key: string]: KnockOutMatch[];
}

export type KnockoutGroup = {
    [key: string]: KnockoutchildType;
}

export type widgetType = 'group' | 'country' | 'knockout' | '';
export interface TabGroupMatches {
    [key: string]: {
        Teamid: number;
    };
}